import React, { useCallback, useEffect, useState } from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import { Form } from "react-bootstrap";
import Swal from "sweetalert2";
import moment from "moment";
//@ts-ignore
import Files from "react-files";
import { useNavigate, useParams } from "react-router-dom";

import { eventService } from "../lib/api/event";
import { routes } from "../routes/routes-names";
import { ReactFilesFile } from "../types/files";
import { isLessThanTheMB } from "../lib/utils/lessthan-max-filesize";
import { Messages } from "../lib/constants/messages";

import "../assets/styles/organisation-registration.css";

interface AttendanceRespPoint {
  eventDate: string;
  weightage: number;
}

interface EventType {
  id: number;
  attendanceRespPoints: AttendanceRespPoint[];
}

const EditEvent: React.FC = () => {
  const navigate = useNavigate();
  const { eventId } = useParams<{ eventId: string }>();

  const [eventData, setEventData] = useState<EventType | null>(null);
  const [attendancePoints, setAttendancePoints] = useState<AttendanceRespPoint[]>([]);
  const [loading, setLoading] = useState(false);

  const [programsheet1, setProgramsheet1] = useState<{ file?: File } | null>(null);
  const [programsheet2, setProgramsheet2] = useState<{ file?: File } | null>(null);
  const [programsheet3, setProgramsheet3] = useState<{ file?: File } | null>(null);
  const [programsheet4, setProgramsheet4] = useState<{ file?: File } | null>(null);
  const [programsheet5, setProgramsheet5] = useState<{ file?: File } | null>(null);
  const [letterHost, setLetterHost] = useState<{ file?: File } | null>(null);

  const initialValues = {
    programsheet1: "",
    programsheet2: "",
    programsheet3: "",
    programsheet4: "",
    programsheet5: "",
    letterHost: "",
  };

  const validationSchema = Yup.object({
    programsheet1: Yup.mixed().required("Required"),
    letterHost: Yup.mixed().required("Required"),
  });

  const handlePointsChange = (index: number, value: number) => {
    const updated = [...attendancePoints];
    updated[index].weightage = value;
    setAttendancePoints(updated);
  };

  const getEventsById = useCallback(async () => {
    if (!eventId) return;
    const { data } = await eventService.getEventById(eventId);
    setEventData(data);
    setAttendancePoints(data.attendanceRespPoints || []);
  }, [eventId]);

  useEffect(() => {
    getEventsById();
  }, [getEventsById]);

  const handleSubmit = async (values: typeof initialValues) => {
    try {
      setLoading(true);

      const eventInfo = {
        ...values,
        attendanceRespPoints:attendancePoints,
        id: Number(eventId),
        createdon: moment().format("YYYY-MM-DD"),
        posttime: moment().format("HH:mm:ss"),
      };

      const formData = new FormData();
      formData.append("eventInfo", JSON.stringify(eventInfo));

      programsheet1?.file && formData.append("programSheet1", programsheet1.file);
      programsheet2?.file && formData.append("programSheet2", programsheet2.file);
      programsheet3?.file && formData.append("programSheet3", programsheet3.file);
      programsheet4?.file && formData.append("programSheet4", programsheet4.file);
      programsheet5?.file && formData.append("programSheet5", programsheet5.file);
      letterHost?.file && formData.append("letterHost", letterHost.file);

      const { success } = await eventService.editEvent(formData);

      if (success) {
        Swal.fire("Success", "Event updated successfully", "success").then(() =>

          navigate(routes.userLayout)
        );
      }
    } catch (err) {
      Swal.fire("Error", "Event update failed", "error");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="org-page">
      <div className="org-container">
        <div className="org-card">
          <h2 className="org-title">Edit CPD Programme</h2>

          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
            enableReinitialize
          >
            {({ setFieldValue, values, errors, touched, handleSubmit }) => (
              <Form onSubmit={handleSubmit}>
                <table className="table">
                  <tbody>
                    {attendancePoints.map((item, index) => (
                      <tr key={item.eventDate}>
                        <td>{item.eventDate}</td>
                        <td>
                          <Form.Control
                            type="number"
                            min={0}
                            max={10}
                            value={item.weightage}
                            onChange={(e) =>
                              handlePointsChange(index, Number(e.target.value))
                            }
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                {/* File Uploads */}
                                  <div className="row mb-2 mt-4">
                                    <div className='text-danger fs-10'>
                                      Please upload images pdfs (.jpeg,.png and .pdf) only, with less than 500 KB size.
                                    </div>
                                    <div className='text-danger fs-10'>
                                      File name should not contain any special charaters and should have less than 20 character length.
                                    </div>
                                  </div>
                                  <div className="row mb-2 mt-4 align-items-center justify-content-center">
                                    <div className="col-4 mt-3">
                                      <div className="drag-img-box d-flex align-items-center justify-content-center">
                                        {values.programsheet1 ? <>
                                          <div className="text-center">
        
                                             <p className="text-success">
                                                Uploaded: {programsheet1?.file?.name || values.programsheet1}
                                              </p>
                                            <button
                                              type="button"
                                              className="btn btn-sm btn-danger"
                                              onClick={() => {
                                                setProgramsheet1(null);
                                                setFieldValue("programsheet1", null);
                                              }
                                              }
                                            >
                                              <i className="bi bi-trash"></i>
                                            </button>
                                          </div>
                                        </> : <>
                                          <Files
                                            className="files-dropzone border p-3"
                                            onChange={(files: ReactFilesFile[]) => {
                                              if (files[0]) {
                                                const file = files[0];
                                                const isLess = isLessThanTheMB(files[0].size, 0.5);
                                                if (isLess) {
                                                  setProgramsheet1({ file });
                                                  setFieldValue("programsheet1", file.name);
                                                }
                                                else {
                                                  alert(Messages.isLessThanTheMB);
                                                }
                                              }
                                            }}
                                            accepts={["application/pdf", "image/*"]}
                                            maxFiles={1}
                                            clickable
                                          >
                                            <div className="text-center">
                                              <i className="bi bi-file-earmark-arrow-up"></i>
                                              <p>
                                                Program sheet 1<span className="text-danger">*</span> </p>
                                            </div>
                                          </Files>
                                        </>}
                                        {errors.programsheet1 && touched.programsheet1 && (
                                          <div className="text-danger">{errors.programsheet1}</div>
                                        )}
                                      </div>
                                    </div>
                
                
                                    <div className="col-4 mt-3">
                                      <div className="drag-img-box d-flex align-items-center justify-content-center">
                                        {values.programsheet2 ? <>
                                          <div className="text-center">
                                            <p className="text-success">
                                                Uploaded: {programsheet2?.file?.name || values.programsheet2}
                                              </p>
                                            <button
                                              type="button"
                                              className="btn btn-sm btn-danger"
                                              onClick={() => {
                                                setProgramsheet2(null);
                                                setFieldValue("programsheet2", null);
                                              }}
                                            >
                                              <i className="bi bi-trash"></i>
                                            </button>
                                          </div>
                                        </> : <>
                                          <Files
                                            className="files-dropzone drag-img-box border p-3"
                                            onChange={(files: ReactFilesFile[]) => {
                                              if (files[0]) {
                                                const file = files[0];
                                                const isLess = isLessThanTheMB(files[0].size, 0.5);
                                                if (isLess) {
                                                  setProgramsheet2({ file });
                                                  setFieldValue("programsheet2", file.name);
                                                }
                                                else {
                                                  alert(Messages.isLessThanTheMB);
                                                }
                                              }
                                            }}
                                            accepts={["application/pdf", "image/*"]}
                                            maxFiles={1}
                                            clickable
                                          >
                                            <div className="text-center">
                                              <i className="bi bi-file-earmark-arrow-up"></i>
                                              <p>Program sheet 2 </p>
                                            </div>
                                          </Files>
                
                
                                        </>}
                
                                        {errors.programsheet2 && touched.programsheet2 && (
                                          <div className="text-danger">{errors.programsheet2}</div>
                                        )}
                
                                      </div>
                                    </div>
                                    <div className="row mb-2 mt-4 align-items-center justify-content-center">
                                      <div className="col-4 mt-3">
                                        <div className="drag-img-box d-flex align-items-center justify-content-center">
                
                                          {values.programsheet3 ? <>
                                            <div className="text-center">
                                              <p className="text-success">Uploaded: {programsheet3?.file?.name || values.programsheet3}</p>
                                              <button
                                                type="button"
                                                className="btn btn-sm btn-danger"
                                                onClick={() => {
                                                  setProgramsheet3(null);
                                                  setFieldValue("programsheet3", null);
                                                }
                                                }
                                              >
                                                <i className="bi bi-trash"></i>
                                              </button>
                                            </div>
                                          </> : <>
                                            <Files
                                              className="files-dropzone border p-3"
                                              onChange={(files: ReactFilesFile[]) => {
                                                if (files[0]) {
                                                  const file = files[0];
                                                  const isLess = isLessThanTheMB(files[0].size, 0.5);
                                                  if (isLess) {
                                                    setProgramsheet3({ file });
                                                    setFieldValue("programsheet3", file.name);
                                                  }
                                                  else {
                                                    alert(Messages.isLessThanTheMB);
                                                  }
                                                }
                                              }}
                                              accepts={["application/pdf", "image/*"]}
                                              maxFiles={1}
                                              clickable
                                            >
                                              <div className="text-center">
                                                <i className="bi bi-file-earmark-arrow-up"></i>
                                                <p>
                                                  Program sheet 3 </p>
                                              </div>
                                            </Files>
                                          </>}
                                          {errors.programsheet3 && touched.programsheet3 && (
                                            <div className="text-danger">{errors.programsheet3}</div>
                                          )}
                                        </div>
                                      </div>
                
                
                
                                      <div className="col-4 mt-3">
                                        <div className="drag-img-box d-flex align-items-center justify-content-center">
                
                
                                          {values.programsheet4 ? <>
                                            <div className="text-center">
                                              <p className="text-success">Uploaded: {programsheet4?.file?.name || values.programsheet4}</p>
                                              <button
                                                type="button"
                                                className="btn btn-sm btn-danger"
                                                onClick={() => {
                                                  setProgramsheet4(null);
                                                  setFieldValue("programsheet4", null);
                                                }}
                                              >
                                                <i className="bi bi-trash"></i>
                                              </button>
                                            </div>
                                          </> : <>
                                            <Files
                                              className="files-dropzone drag-img-box border p-3"
                                              onChange={(files: ReactFilesFile[]) => {
                                                if (files[0]) {
                                                  const file = files[0];
                                                  const isLess = isLessThanTheMB(files[0].size, 0.3);
                                                  if (isLess) {
                                                    setProgramsheet4({ file });
                                                    setFieldValue("programsheet4", file.name);
                                                  }
                                                  else {
                                                    alert(Messages.isLessThanTheMB);
                                                  }
                                                }
                                              }}
                                              accepts={["application/pdf", "image/*"]}
                                              maxFiles={1}
                                              clickable
                                            >
                                              <div className="text-center">
                                                <i className="bi bi-file-earmark-arrow-up"></i>
                                                <p>Program sheet 4 </p>
                                              </div>
                                            </Files>
                                          </>}
                
                                          {errors.programsheet4 && touched.programsheet4 && (
                                            <div className="text-danger">{errors.programsheet4}</div>
                                          )}
                
                                        </div>
                                      </div>
                                      <div className="row mb-2 mt-4 align-items-center justify-content-center">
                                        <div className="col-4 mt-3">
                                          <div className="drag-img-box d-flex align-items-center justify-content-center">
                
                                            {values.programsheet5 ? <>
                                              <div className="text-center">
                                                <p className="text-success">Uploaded: {programsheet5?.file?.name || values.programsheet5}</p>
                                                <button
                                                  type="button"
                                                  className="btn btn-sm btn-danger"
                                                  onClick={() => {
                                                    setProgramsheet5(null);
                                                    setFieldValue("programsheet5", null);
                                                  }
                                                  }
                                                >
                                                  <i className="bi bi-trash"></i>
                                                </button>
                                              </div>
                                            </> : <>
                                              <Files
                                                className="files-dropzone border p-3"
                                                onChange={(files: ReactFilesFile[]) => {
                                                  if (files[0]) {
                                                    const file = files[0];
                                                    const isLess = isLessThanTheMB(files[0].size, 0.5);
                                                    if (isLess) {
                                                      setProgramsheet5({ file });
                                                      setFieldValue("programsheet5", file.name);
                                                    }
                                                    else {
                                                      alert(Messages.isLessThanTheMB);
                                                    }
                                                  }
                                                }}
                                                accepts={["application/pdf", "image/*"]}
                                                maxFiles={1}
                                                clickable
                                              >
                                                <div className="text-center">
                                                  <i className="bi bi-file-earmark-arrow-up"></i>
                                                  <p>
                                                    Program sheet 5</p>
                                                </div>
                                              </Files>
                                            </>}
                                            {errors.programsheet5 && touched.programsheet5 && (
                                              <div className="text-danger">{errors.programsheet5}</div>
                                            )}
                                          </div>
                                        </div>
                                        <div className="col-4 mt-3">
                                          <div className="drag-img-box d-flex align-items-center justify-content-center">
                
                                            {values.letterHost ? <>
                                              <div className="text-center">
                                                <p className="text-success">Uploaded: {letterHost?.file?.name || values.letterHost}</p>
                                                <button
                                                  type="button"
                                                  className="btn btn-sm btn-danger"
                                                  onClick={() => {
                                                    setLetterHost(null);
                                                    setFieldValue("letterHost", null);
                                                  }}
                                                >
                                                  <i className="bi bi-trash"></i>
                                                </button>
                                              </div>
                                            </> : <>
                                              <Files
                                                className="files-dropzone drag-img-box border p-3"
                                                onChange={(files: ReactFilesFile[]) => {
                                                  if (files[0]) {
                                                    const file = files[0];
                                                    const isLess = isLessThanTheMB(files[0].size, 0.5);
                                                    if (isLess) {
                                                      setLetterHost({ file });
                                                      setFieldValue("letterHost", file.name);
                                                    }
                                                    else {
                                                      alert(Messages.isLessThanTheMB);
                                                    }
                                                  }
                                                }}
                                                accepts={["application/pdf", "image/*"]}
                                                maxFiles={1}
                                                clickable
                                              >
                                                <div className="text-center">
                                                  <i className="bi bi-file-earmark-arrow-up"></i>
                                                  <p>Letter <span className="text-danger">*</span></p>
                                                </div>
                                              </Files>
                
                                            </>}
                
                                            {errors.letterHost && touched.letterHost && (
                                              <div className="text-danger">{errors.letterHost}</div>
                                            )}
                
                                          </div>
                                        </div>
                                      </div>
                
                                    </div>
                                  </div>

                <div className="form-actions">
                  <button type="submit" className="btn-submit" disabled={loading}>
                    {loading ? "Submitting..." : "Submit"}
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </div>
  );
};

export default EditEvent;
